<template>
  <div></div>
</template>

<script>
import fileDownload from "js-file-download";
export default {
  created() {
    this.download();
  },
  methods: {
    download() {
      const _this = this;
      _this.$axios
        .get(
          _this.config.path + "/kubeconfigs/" + _this.$route.params.filename,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
            responseType: "blob",
          }
        )
        .then(function(res) {
          fileDownload(res.data, _this.$route.params.filename);
        })
        .catch(function(err) {
          _this.$message["error"]({
            message: "下载失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
    },
  },
};
</script>
